<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <title>Daylily</title>
    <base href="/">
    <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">
    <link rel="icon" type="image/x-icon" href="favicon.ico">
    <link href="https://cdn.syncfusion.com/ej2/material.css" rel="stylesheet" />
    <link rel="stylesheet" href="/assets/css/main.css" />
  </head>
  <body>
    <div id="page-wrapper"> 
  
  <!-- Header -->
  <div id="header-wrapper">
    <div id="header" class="container" id="logo">
    <nav id="nav-hor" class="nav">
      <ejs-menu orientation='Horizontal' [items]='horMenuItems' [fields]='menuFields'></ejs-menu>
    </nav>
    <div id="nav-vert" class="nav e-section-control"> 
      <!-- To render DropDownButton. -->
      <button id="nav-vert-" ejs-dropdownbutton [items]='vertMenuItems'  iconCss='e-icons e-menu' cssClass='e-caret-hide'></button>
    </div>
  </div>
</div>
<!-- Main -->
<div id="main-wrapper">
  <div class="container" id="main">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Footer -->
<div id="footer-wrapper">
  <div id="footer" class="container">
    <app-contact-form></app-contact-form>
  </div>
  <div id="copyright" class="container">
    <ul class="menu">
      <li>&copy; Daylily Birth and Breastfeeding. All rights reserved.</li>
      <li>Build Date: {{buildDate}}</li>
    </ul>
  </div>
</div>
</div>
</body>
</html>
